/**
 * Style constants for exercises.
 */

export default {
    // The non-mobile width and padding of the wrapper around exercises
    wrapperWidth: 688,

    wrapperPadding: 16,
    footerHorizontalPadding: 16,

    zIndexes: {
        // HACK(emily): These z-indexes are carefully chosen to coordinate with
        // several elements on the page. In particular, we want:
        // The footer and backdrop to be above the header (z-index of 1060)
        // The footer and backdrop to be above perseus content (z-index <= 100)
        // The backdrop should be below selected perseus choices but
        // the footer should be above selected perseus choices (z-index of 1062)
        //
        // footer ----
        //          ------ selected choices
        // backdrop ------
        // header -----
        //          ------ other perseus content
        //
        // TODO(emily): rewrite these using my new fancy z-index library.
        footer: 1063,
        backdrop: 1061,

        drawingArea: 1,
        aboveDrawingArea: 2,
        interactiveComponent: 3,
    },

    chromeSizes: {
        // The exercise footer on phones and tablets is perpetually fixed to the
        // bottom of the page. As such, when it's active, other components need to
        // resize to accommodate it (typically, by adding some bottom-padding).
        // It's unfortunate that we can't encapsulate this layout information
        // within, e.g., the exercise page or exercise chrome components, but given
        // the global nature of the layout, the effects are more far-reaching (for
        // example, the left sidebar, which is rendered above any exercise-related
        // components, also needs to account for this footer).
        //
        // note(matthewc): the exercise footer seems to be made to look like the
        // WB Toolbar which is used for articles. For Perseus, we need a uniform
        // height to lay the keypad on top of and the toolbar is 66px high.
        // (Plus is just looks nice to have a consistent experience)
        exercisePhoneFooterHeight: 66,
    },
};
